export default "\n<!-- <app-nav></app-nav> -->\n\n<router-outlet></router-outlet>\n"